export function regionsQuery() {
    return JSON.stringify({
        query: `
            query Regions {
                regions {
                    id
                    name
                }
            }
        `,
    });
}
